import React, { useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { DataContext } from '../../../context/DataContext';

import { getRol, getToken, getUser } from '../../../api/Account';
import { getBosqueMoraAsync } from '../../../api/Report';
import { getGestoresAsync } from '../../../api/Users';
import { simpleMessage } from '../../../helpers/Helpers';
import ReporteAgrupado from '../../../components/reportes/ReporteAgrupado';

const TODOS = 't';

// Cada tramo cuenta creditos (no dinero) en mora de ese gestor; se suman tal cual.
const tramo = (key, label) => ({
	key,
	label,
	align: 'center',
	total: true,
	valor: (fila) => fila[key]
});

const COLUMNAS = [
	{
		key: 'gestor',
		label: 'Gestor',
		align: 'left',
		texto: true,
		valor: (fila) => fila.gestor
	},
	tramo('temprana', 'Temprana'),
	tramo('avanzada', 'Avanzada'),
	tramo('riesgo', 'Riesgo'),
	tramo('riesgoPerdido', 'Riesgo Perdido'),
	tramo('vencido', 'Vencido')
];

const BosqueMora = () => {
	const [data, setData] = useState([]);
	const [gestorName, setGestorName] = useState('Todos');

	const { selectedGestor } = useParams();
	const { setIsLoading, setIsUnautorized, title, slogan, icon } = useContext(DataContext);

	const token = getToken();
	const user = getUser();
	const rol = getRol();

	const manejarError = useCallback(
		(result) => {
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
		},
		[setIsUnautorized]
	);

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			const [reporte, gestores] = await Promise.all([
				getBosqueMoraAsync(token, selectedGestor === TODOS ? 0 : parseInt(selectedGestor)),
				selectedGestor === TODOS ? null : getGestoresAsync(token)
			]);
			setIsLoading(false);

			if (!reporte.statusResponse) {
				manejarError(reporte);
				return;
			}
			setData(reporte.data.result);

			if (selectedGestor !== TODOS) {
				// Si la lista de gestores falla o no lo trae (dado de baja), el nombre sale del reporte.
				const gestor =
					gestores && gestores.statusResponse
						? gestores.data.result.find((g) => g.id.toString() === selectedGestor)
						: null;
				setGestorName(
					gestor ? gestor.fullName : reporte.data.result[0]?.gestor ?? selectedGestor
				);
			}
		})();
	}, [token, selectedGestor, setIsLoading, manejarError]);

	// El reporte no trae un id por fila: se numera para tener una clave estable.
	const filas = useMemo(() => data.map((fila, indice) => ({ ...fila, id: indice })), [data]);

	return (
		<ReporteAgrupado
			tituloReporte="Reporte de Bosque de Mora"
			nombreArchivo="BosqueMora"
			parametros={[{ label: 'Gestor Seleccionado', valor: gestorName }]}
			columnas={COLUMNAS}
			data={filas}
			unidad="gestor"
			unidadPlural="gestores"
			ordenInicial="gestor"
			contexto={{ title, slogan, icon, user, rol }}
		/>
	);
};

export default BosqueMora;
